export default {
    SYNC_IN_PROGRESS: 'SYNC_IN_PROGRESS',
    SYNCED: 'SYNCED',
};
